import { useState, useEffect } from "react";

const KEY = "riq-consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(false);
  const [customize, setCustomize] = useState(false);
  const [analytics, setAnalytics] = useState(true);
  const [functional, setFunctional] = useState(true);

  useEffect(() => {
    if (!localStorage.getItem(KEY)) setVisible(true);
  }, []);

  const save = (a, f) => {
    localStorage.setItem(KEY, JSON.stringify({ necessary: true, analytics: a, functional: f, ts: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-[60] p-4" role="dialog" aria-label="Cookie consent" data-testid="cookie-banner">
      <div className="card-brut max-w-3xl mx-auto p-5 sm:p-6">
        <p className="eyebrow mb-2">Your privacy, itemized</p>
        <p className="text-sm text-[#4A5A63] leading-relaxed">
          Like our pricing, our cookies come with full disclosure. Necessary cookies keep the site running; analytics help us understand what converts. Choose what you allow — no dark patterns, no pre-ticked traps.
        </p>
        {customize && (
          <div className="mt-4 grid sm:grid-cols-3 gap-3" data-testid="cookie-preferences">
            <div className="border border-[#D8E2E6] p-3 bg-[#F7F9FA]">
              <p className="font-mono2 text-xs font-bold uppercase tracking-wider">Necessary</p>
              <p className="text-xs text-[#4A5A63] mt-1">Always on. The site breaks without these.</p>
            </div>
            <label className="border border-[#D8E2E6] p-3 bg-white cursor-pointer flex flex-col gap-1">
              <span className="flex items-center justify-between font-mono2 text-xs font-bold uppercase tracking-wider">
                Analytics
                <input type="checkbox" checked={analytics} onChange={(e) => setAnalytics(e.target.checked)} className="w-4 h-4 accent-[#0E7A8F]" data-testid="cookie-analytics-toggle" />
              </span>
              <span className="text-xs text-[#4A5A63]">GA4 conversion measurement.</span>
            </label>
            <label className="border border-[#D8E2E6] p-3 bg-white cursor-pointer flex flex-col gap-1">
              <span className="flex items-center justify-between font-mono2 text-xs font-bold uppercase tracking-wider">
                Functional
                <input type="checkbox" checked={functional} onChange={(e) => setFunctional(e.target.checked)} className="w-4 h-4 accent-[#0E7A8F]" data-testid="cookie-functional-toggle" />
              </span>
              <span className="text-xs text-[#4A5A63]">Remembers your preferences.</span>
            </label>
          </div>
        )}
        <div className="mt-5 flex flex-wrap gap-3">
          <button className="btn-primary !py-2.5 !text-xs" onClick={() => save(true, true)} data-testid="cookie-accept-btn">Accept all</button>
          <button className="btn-outline !py-2.5 !text-xs" onClick={() => save(false, false)} data-testid="cookie-reject-btn">Necessary only</button>
          <button className="btn-outline !py-2.5 !text-xs" onClick={() => (customize ? save(analytics, functional) : setCustomize(true))} data-testid="cookie-customize-btn">
            {customize ? "Save preferences" : "Customize"}
          </button>
        </div>
      </div>
    </div>
  );
};
